<!-- Tabla de eventos de organizador (Se usa en la vista src/views/admin/Home.vue)-->
<!-- El componente obtiene los datos de los eventos con una consulta directa con express y mongoose-->
<template>
  <v-row justify="center" class="elevation-2 pa-5">
    <v-col cols="12">
      <h2 class="headline font-weight-bold">Eventos</h2>
      <v-divider></v-divider>

      <!-- CONTENIDO DE LA TABLA -->
      <v-data-table
        no-data-text="No hay datos disponibles."
        no-results-text="No hay datos disponibles."
        loading-text="Cargando datos..."
        class="table-header"
        :headers="eventsHeaders"
        :items="eventData"
        :items-per-page="($vuetify.breakpoint.xsOnly)?3:6"
        :loading="loading"
        :header-props="{
          sortByText:'Ordenar por'
        }"
        :footer-props="{
          itemsPerPageText: 'Filas por página',
          itemsPerPageAllText:'Todas',
        }"
      >
        <template v-slot:body="{items}">
          <tbody>
            <tr
              v-for="(item, index) in items"
              :key="index"
              class="text-center"
              :class="[($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-table-row':'' ]"
            >
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':'eventNameTD'">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{eventsHeaders[0].text}}</div>
                <div
                  :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                >{{item.name}}</div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{eventsHeaders[1].text}}</div>
                <div
                  :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                >{{ item.date | date }}</div>
              </td>
              <!--<td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold v-data-table__mobile-row__header d-flex d-sm-none"
                >{{eventsHeaders[2].text}}</div>
                <div :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''">
                  <v-chip
                    class="pointer"
                    color="teal"
                    dark
                    @click.native.stop="details(item.id)"
                  >{{ item.assistants }}</v-chip>
                </div>
              </td>-->
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold v-data-table__mobile-row__header d-flex d-sm-none"
                >{{eventsHeaders[2].text}}</div>
                <div :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''">
                  <v-chip
                    class="pointer"
                    color="teal"
                    dark
                    @click.native.stop="details(item.id)"
                  >Ver asistentes</v-chip>
                  <!--
                  <div
                    :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                  >{{item.assistants}}</div>
                  -->
                </div>
              </td>
              <!--<td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold v-data-table__mobile-row__header d-flex d-sm-none"
                >{{eventsHeaders[4].text}}</div>
                <div
                    :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                  >${{ item.sales | currency }}</div>
              </td>-->
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold v-data-table__mobile-row__header d-flex d-sm-none"
                >{{eventsHeaders[3].text}}</div>
                <div :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-chip
                        class="pointer"
                        color="blue-grey"
                        dark
                        v-on="on"
                        @click="getEventTransactions(item)"
                      >
                        Información del evento
                      </v-chip>
                    </template>
                    <span>Ver cantidad de asistentes y ventas del evento</span>
                  </v-tooltip>
                </div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold v-data-table__mobile-row__header d-flex d-sm-none"
                >{{eventsHeaders[4].text}}</div>
                <div :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''">
                  <v-tooltip top v-if="item.courtesy && item.quantityOfCourtesies > 0">
                    <template v-slot:activator="{ on }">
                      <v-chip
                        class="pointer"
                        color="cyan lighten-1"
                        dark
                        @click="downloadCsv(item.name, item.courtesy, item.quantityOfCourtesies)"
                        v-on="on"
                      >Cortesías</v-chip>
                    </template>
                    <span>Descargar lista de cortesías.</span>
                  </v-tooltip>
                  <v-tooltip top v-else>
                    <template v-slot:activator="{ on }">
                      <v-chip
                        class="pointer"
                        color='grey lighten-1'
                        dark
                        v-on="on"
                      >N/D</v-chip>
                    </template>
                    <span>No se han configurado cortesias para este evento.</span>
                  </v-tooltip>
                </div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold v-data-table__mobile-row__header d-flex d-sm-none"
                >{{eventsHeaders[5].text}}</div>
                <div :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-chip
                        class="pointer"
                        color="blue"
                        dark
                        v-on="on"
                        v-clipboard:copy="shareItem(item.id)"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >
                        Copiar URL
                      </v-chip>
                    </template>
                    <span>https://v2.wechamber.mx/eventos/{{item.id}}</span>
                  </v-tooltip>
                </div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold v-data-table__mobile-row__header d-flex d-sm-none"
                >{{eventsHeaders[6].text}}</div>
                <div :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''">
                  <v-chip
                    class="pointer"
                    color="orange"
                    dark
                    @click="editItem(item, true)"
                  >Editar</v-chip>
                </div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold v-data-table__mobile-row__header d-flex d-sm-none"
                >{{eventsHeaders[7].text}}</div>
                <div :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''">
                  <v-chip
                    class="pointer"
                    color="red darken-4"
                    dark
                    @click="openDialog(item)"
                  >Eliminar</v-chip>
                </div>
              </td>
              <td v-if="user.surveyModule" :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold v-data-table__mobile-row__header d-flex d-sm-none"
                >{{eventsHeaders[8].text}}</div>
                <div :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''">
                  <v-chip
                    class="pointer"
                    color="success darken-4"
                    dark
                    :disabled="!item.hasSurvey"
                    @click="openSurveyDialog(item)"
                  >Editar encuesta</v-chip>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>

      <!-- DIALOG PARA LA ELIMINACIÓN DE UN EVENTO EN ESPECÍFICO -->
      <v-dialog v-if="deleteDialog" v-model="deleteDialog" max-width="500" overlay-opacity="0.2">
        <v-card>
          <h2 class="display-1 px-7 py-5">¿Estás seguro de querer eliminar el evento?</h2>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteDialog = false">Cancelar</v-btn>
            <v-btn color="error" depressed @click="confirmEventDelete()">Eliminar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- DIALOG PARA VER INFORMACIÓN DE FACTURACIÓN -->
      <v-dialog v-if="transactionsEventDialog" v-model="transactionsEventDialog" max-width="550" overlay-opacity="0.2">
        <v-card>
          <p class="headline font-weight-bold text-center pt-5">{{transactionsEventData.name}}</p>
          <v-divider class="pt-3"></v-divider>
          <div class="mx-5">

            <p><strong>Fecha de evento:</strong> {{transactionsEventData.date | date }}</p>
            <p><strong>Cantidad de asistentes:</strong> {{transactionsEventData.attendees}}</p>
            <p><strong>Ventas totales de evento:</strong> ${{ transactionsEventData.sales==0? "0":  transactionsEventData.sales | currency }}</p>
            <p><strong>URL de evento:</strong> https://v2.wechamber.mx/eventos/{{transactionsEventData.id}}</p>
          </div>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="ma-1" color="primary" @click="transactionsEventDialog = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- DIALOG PARA EDITAR LA CONFIGURACIÓN DE UNA ENCUESTA -->
      <v-dialog v-if="surveyDialog" v-model="surveyDialog" max-width="500" overlay-opacity="0.2">
        <v-card class="px-7 py-5">
          <h2 class="display-1">Editar encuesta</h2>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-text-field
                  v-model="selectedItem.editorEmail"
                  :rules="emailRules"
                  label="Correo electrónico del editor *"
                  required
                  prepend-icon="fas fa-envelope"
                  :error-messages="validateEmail(selectedItem.editorEmail)"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0">
                <v-menu
                  v-model="surveyDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="surveyDateFormatted"
                      label="Fecha de termino de la encuesta *"
                      persistent-hint
                      readonly
                      v-on="on"
                      prepend-icon="fas fa-calendar-day"
                      required
                      :rules="surveyEndDateRules"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="selectedItem.surveyEndDate"
                    no-title
                    @input="surveyDateMenu = false"
                    :min="selectedItem.endDate"
                    locale="es"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" class="pt-0">
                <v-chip
                class="pointer"
                color="accent"
                :href="selectedItem.editorURL"
                target="_blank" dark>

                Ver encuesta
                </v-chip>
              </v-col>
            </v-row>
          </v-form>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="surveyDialog = false">Cancelar</v-btn>
            <v-btn :loading="updatingSurvey" :disabled="!this.valid" color="success" depressed @click="updateSurveyData">Actualizar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
import exportFromJSON from "export-from-json";
//Helpers
import { validations } from "@/helpers/validations.js";
export default {
  data() {
    return {
      updatingSurvey: false,
      deleteDialog: false,
      surveyDialog: false,
      transactionsEventDialog: false,
      transactionsEventData: {},
      loading: true,
      eventData: [],
      selectedItem: {},
      surveyDateMenu: false,
      surveyEndDateRules: validations.requiredFValidation(
        "fecha de termino"
      ),
      emailRules: validations.emailValidation(),
      valid: false,
      eventsHeaders: [
        { align: "center", text: "Nombre", value: "name" },
        { align: "center", text: "Fecha", value: "date", width: "130px" },
        //{ align: "center", text: "Asistentes", value: "assistants" },
        { align: "center", text: "Ver asistentes", value: "viewAssistants" },
        //{ align: "center", text: "Ventas", value: "sales" },
        { align: "center", text: "Información del evento", value: "action" },
        { align: "center", text: "Cortesías de evento", value: "courtesy"},
        { align: "center", text: "URL de evento", value: "url"},
        {
          align: "center",
          text: "Editar",
          value: "action"
        },
        {
          align: "center",
          text: "Eliminar",
          value: "action"
        },
      ]
    };
  },
  computed: {
    ...mapState("user", ["user"]),
    ...mapState("event", ["events", "eventAttendeesTransactions"]),

    // Función para dar formato de la fecha termino de la encuesta.
    surveyDateFormatted() {
      return this.selectedItem.surveyEndDate ? this.formatDate(this.selectedItem.surveyEndDate.substring(0, 10)) : null
    },
    todayDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },
  },
  methods: {
    ...mapActions("event", ["deleteEvent", "fetchOrganizerEventsApi", "fetchEventAttendeesTransactionsApi", "updateSurvey"]),
    ...mapMutations("notifications", ["show"]),

    // Validar que el correo sea del dominio gmail
    validateEmail(email) { 
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(re.test(email)){
        return (email.indexOf("@gmail.com", email.length - "@gmail.com".length) !== -1) ? '' : 'El email debe ser una cuenta de gmail'
      }
    },
    /**
     * Funcion para actualizar la fecha de cierre de una encuesta
     */
    async updateSurveyData(){
      const { id, surveyEndDate, editorEmail, editorURL } = this.selectedItem
      try {
        this.updatingSurvey = true;
        await this.updateSurvey({ id, surveyEndDate, editorEmail, editorURL });
        this.updatingSurvey = false;
        this.surveyDialog = false;
        this.show({ text: "¡Encuesta actualizada con éxito! 😄" });
      } catch (error) {
        this.show({ text: "Verifica que la cuenta de correo sea válida", color: "error"});
        this.updatingSurvey = false;
      }
    },
    /**
     * Función para dar formato de fecha YYYY-MM-DD.
     * @param {String} date Fecha inicial o final del evento.
     */
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    /**
     * Función que obtiene la cantidad de asistentes de cada evento
     * @param { Array.<Object.<string, string>> } orders Arreglo con todas las transacciones
     * de un evento.
     */
    getAttendees(orders) {
      let filteredOrders = orders.filter(
        order => order.orderStatus != "IN_PROGRESS"
      );
      let attendeesArray = filteredOrders.map(order => {
        return order.attendeeInformation.length;
      });
      return attendeesArray.reduce((a, b) => a + b, 0);
    },

    /**
     * Función que obtiene las ventas de cada evento
     * @param { Array.<Object.<string, string>> } orders Arreglo con todas las transacciones
     * de un evento.
     */
    getSales(orders) {
      let filteredOrders = orders.filter(
        order => order.orderStatus != "IN_PROGRESS"
      );
      let salesArray = filteredOrders.map(order => {
        return order.total;
      });
      return salesArray.reduce((a, b) => a + b, 0);
    },

    /**
     * Función para ver los detalles de un evento en específico.
     * @param { string } id Identificador del evento.
     */
    details(id) {
      this.$router.push({ name: "admin-assistants-paginate-details", params: { id } });
    },

    /**
     * Función para editar la información de un evento.
     * @param { Object.<string, string> } item Un objeto con los datos de un evento.
     */
    editItem(item, isEvent) {
      this.$router.push({
        name: "admin-update-event",
        params: { id: item.id }
      });
    },

    /**
     * Función para mostrar la ventana de confirmación para eliminar un evento.
     * @param { Object.<string, string> } item Un objeto con los datos de un evento.
     */
    openDialog(item) {
      this.deleteDialog = true;
      this.selectedItem = item;
    },
    /**
     * Función para mostrar la ventana para editar la encuesta de un evento
     * @param { Object.<string, string> } item Un objeto con los datos de un evento.
     */
    openSurveyDialog(item) {
      this.surveyDialog = true;
      this.selectedItem = item;
      console.log(this.selectedItem);
    },
    /**
     * Función que elimina el evento seleccionado.
     */
    async confirmEventDelete() {
      await this.deleteEvent(this.selectedItem.id);
      await this.formatEventData();
      this.deleteDialog = false;
    },

    /**
     * Función para dar formato al objeto de la base de datos para su uso en la data table.
     */
    async formatEventData() {
      await this.fetchOrganizerEventsApi();
      this.eventData = this.events.map(event => {
        return {
          id: event._id,
          name: event.name,
          date: event.startDate
            ? event.startDate.substring(0,10)
            : "En línea",
          //assistants:
          //  event.orders.length > 0 ? this.getAttendees(event.orders) : 0,
          //sales: event.orders.length > 0 ? this.getSales(event.orders) > 0 ? this.getSales(event.orders) : "0" : "0",
          quantityOfCourtesies : event.quantityOfCourtesies,
          courtesy: event.courtesy,
          endDate: event.endDate,
          hasSurvey: event.hasSurvey,
          editorURL: event.editorURL,
          editorEmail: event.editorEmail,
          surveyEndDate: event.surveyEndDate
        };
      });
      this.loading = false;
    },

    /**
     * Función para ver la cantidad de asistentes y ventas totales de un evento
     * @param { String } event objeto de evento para hacer la consulta de sus ordenes y obtener los ingresos por evento y la cantidad de asistentes
     */
    async getEventTransactions(event) {
      await this.fetchEventAttendeesTransactionsApi(event.id);
      this.transactionsEventData.id = event.id;
      this.transactionsEventData.date = event.date;
      this.transactionsEventData.name = this.eventAttendeesTransactions.name;
      this.transactionsEventData.sales = this.getSales(this.eventAttendeesTransactions.orders);
      this.transactionsEventData.attendees = this.getAttendees(this.eventAttendeesTransactions.orders);
      this.transactionsEventDialog = true;
    },

    /**
     * Función para descargar lista de cortesias por evento.
     * @param {String} eventName Nombre de evento.
     * @param {Array<String>} courtesies Lista de cortesías.
     * @param {Integer} quantityOfCourtesies Número de cortesías.
     */
    async downloadCsv(eventName, courtesies, quantityOfCourtesies) {
      let data = [];
      courtesies.length = quantityOfCourtesies;
      courtesies.forEach(async courtesy => {
        let element = {};
        element.cortesia = courtesy;
        await data.push(element);
      })
      const fileName = `${eventName} cortesías`;
      const exportType = "csv";
      exportFromJSON({ data, fileName, exportType });
    },

    /**
     * Función que devuelve un link para compartir el evento seleccionado.
     * @param { string } id Identificador único de un evento.
     */
    shareItem(id) {
      return `https://v2.wechamber.mx/eventos/${id}`
    },

    /**
     * Función que muestra una notificación de exito al copiar un link para compartir.
     */
    onCopy: function(e) {
      this.show({ text: "¡Se ha copiado la url del evento al portapapeles! 😄" });
    },

    /**
     * Función que muestra una notificación de error en caso de que algo salga mal al
     * copiar un link para compartir.
     */
    onError: function(e) {
      this.show({ text: "¡Hubo un problema al copiar la url del evento!" });
    }
  },
  async mounted() {
    //await this.fetchOrganizerEventsApi();
    await this.formatEventData();
    // Este condicional habilita la nueva columna para encuestas solo para un organizador en específico.
    if(this.user.surveyModule){
      let survey = {
        align: "center",
        text: "Encuesta",
        value: "action"
      }
      this.eventsHeaders.push(survey);
    }
  }
};
</script>
<style scoped>
a{
  color: inherit;
  text-decoration: none;
}
@media (min-width: 1264px) {
  td {
    width: 50px;
  }
  .eventNameTD {
    min-width: 180px;
  }
}
.table-header >>> thead {
  background-color: rgb(231, 231, 231);
}
</style>
